if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.pincodeData = [];
        this.monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        this.weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
        this.clickEvent();
        this.getData();
      }

      getData = async () => {
        let form = qs('.delivery-option-wrapper',this);
        let url = form?.getAttribute('data-express');
        try{
          let data = await fetch(url);
          data = await data.json();
          this.pincodeData = data;
        }catch(e){
          console.log(e);
        }
      }

      findETA = (estimateBtn,checkPincodeText,updateDate,etaResult,etaResultText) => {
        let input = qs('.delivery-option-wrapper .pincode-eta-input',this);
        let deliveryInformation = qs('.delivery-option-wrapper .delivery-information',this);
        let value = input.value;
        let eta = this.pincodeData.find((item)=> parseInt(item.Pincode) == parseInt(value));
        if(eta){
          let currentDate = new Date(window.currentDate);
          currentDate.setDate(currentDate.getDate() + parseInt(eta.T));
          updateDate.innerHTML = `Get it by ${this.weekday[currentDate.getDay()]}, ${this.monthNames[currentDate.getMonth()]} ${currentDate.getDate()}`
          checkPincodeText.innerText = 'check';
          estimateBtn.classList.add('change-active');
          deliveryInformation.classList.add('active');
        }else{
          etaResult.innerText = "We are currently not delivering to this pin code."
          etaResult.classList.add('text-danger');
          checkPincodeText.innerText = 'check';
          estimateBtn.classList.remove('change-active');
          deliveryInformation.classList.remove('active');
          setTimeout(() => {
            input.value = '';
            input.focus();
            etaResult.innerText = etaResultText;
            etaResult.classList.remove('text-danger');
          }, 3000);
        }
      }

      clickEvent = () => {
        let view_text = qs('.product__info-wrapper .view-all-text');
        let View_all_popup = qs('.view-more-popup-wrapper');
        let close_btn = qs('.popup-header .close-icon');
        view_text?.addEventListener('click', () => {
          View_all_popup.classList.add('popup-open');
          document.body.classList.add(`overflow-hidden`);
        })
        close_btn?.addEventListener('click', () => {
          View_all_popup.classList.remove('popup-open');
          document.body.classList.remove(`overflow-hidden`);
        })
        View_all_popup?.addEventListener('click', (e) => {
          if(e.target !== e.currentTarget) return;
          View_all_popup.classList.remove('popup-open');
          document.body.classList.remove(`overflow-hidden`);
        })

        // estimated delivery
        let estimateBtn = qs('.estimated-delivery-button',this);
        let etaResult = qs('.delivery-option-wrapper .information-text',this);
        let etaResultText = etaResult.innerText;
        let input = qs('.delivery-option-wrapper .pincode-eta-input',this);
        let updateDate = qs('.delivery-option-wrapper .update-date',this);
        let updateDateText = updateDate.innerText;
        let deliveryInformation = qs('.delivery-option-wrapper .delivery-information',this);
        input?.addEventListener('input',async ()=> {
          let value = input.value;
          if (value.length > 6) input.value = value.slice(0, 6);
          if(!value){
            estimateBtn.classList.remove('change-active');
            deliveryInformation.classList.remove('active');
            updateDate.innerText = updateDateText;
          }
        })
        estimateBtn?.addEventListener('click',async ()=> {
          if (estimateBtn.classList.contains('change-active')) {
            input.value = '';
            input.focus();
            estimateBtn.classList.remove('change-active');
            deliveryInformation.classList.remove('active');
            updateDate.innerText = updateDateText;
            return;
          }
          let checkPincodeText = qs('.check-pincode-text',estimateBtn);
          let value = input.value;
          if(!value) {
            etaResult.innerText = 'Please Enter a Valid Pincode';
            etaResult.classList.add('text-danger');
            setTimeout(() => {
              etaResult.innerText = etaResultText;
              etaResult.classList.remove('text-danger');
            }, 2000);
            return;
          }
          checkPincodeText.innerText = 'Checking...';
          if(this.pincodeData.length <= 0){
            await this.getData();
            this.findETA(estimateBtn,checkPincodeText,updateDate,etaResult,etaResultText);
          }else{
            this.findETA(estimateBtn,checkPincodeText,updateDate,etaResult,etaResultText);
          }
        })
      }
    }
  );
}